import "./src/styles/global.css";
import React from "react";
import Root from "./src/components/Root";

export const wrapRootElement = ({ element }) => <Root>{element}</Root>;
